 /* eslint-disable */
import { defineStore } from 'pinia';
import { useFavouritesStore } from './favourites';
import { useRegionsStore } from './regions';
import _ from 'lodash';

export const useCouponsStore = defineStore('coupons', {
	state: () => ({
		competition_ids: [],
		all_expanded: true,
		next_hour_fixtures: null,
		fixtures_loading: false,
	}),
	getters: {
		selectedCompetitionIds(state) {
			return state.competition_ids;
		},
		isRegionChecked: (state) => (region) => {
			for (const competition_key in region.competitions) {
				const competition = region.competitions[competition_key];
				if (!state.competition_ids.includes(competition.id)) return false;
			}

			return true;
		},
		isCompetitionChecked: (state, getters) => (competition_id) => {
			if (state.competition_ids.includes(competition_id)) return true;

			return false;
		},
		nextHourFixturesPerHour(state) {
			const favouritesStore = useFavouritesStore();

			let fixtures = _.cloneDeep(state.next_hour_fixtures);
			for (const key in fixtures) {
				if (Object.hasOwnProperty.call(fixtures, key)) {
					fixtures[key]['competition_region_name'] = fixtures[key].region_name + ' - ' + fixtures[key].competition_name;
					fixtures[key]['favourite'] = false;

					if (favouritesStore.favouriteFixtureIds.includes(fixtures[key].id)) {
						fixtures[key]['favourite'] = true;
					}
				}
			}

			return _.orderBy(fixtures, ['start_datetime', 'asc']);
		},
		nextHourFixturesPerCompetition5: (state) => (fixtures_count) => {
			const favouritesStore = useFavouritesStore();

			let fixtures = _.cloneDeep(state.next_hour_fixtures);
			fixtures =_.chain(fixtures).orderBy(['competition_weight', 'competition_region_name'], ['desc', 'asc']).take(fixtures_count).value();

			for (const key in fixtures) {
				if (Object.hasOwnProperty.call(fixtures, key)) {
					fixtures[key]['competition_region_name'] = fixtures[key].region_name + ' - ' + fixtures[key].competition_name;

					if (favouritesStore.favouriteFixtureIds.includes(fixtures[key].id)) {
						fixtures[key]['favourite'] = true;
					}
				}
			}

			const competitions = _.chain(fixtures).orderBy(['competition_weight', 'competition_region_name'], ['desc', 'asc']).groupBy('competition_region_name').value();

			for (const competition in competitions) {
				competitions[competition] = _.chain(competitions[competition]).orderBy(['start_datetime', 'asc']).value();
			}

			return competitions;
		},
		nextHourFixturesPerCompetition(state) {
			const favouritesStore = useFavouritesStore();

			let fixtures = _.cloneDeep(state.next_hour_fixtures);

			for (const key in fixtures) {
				if (Object.hasOwnProperty.call(fixtures, key)) {
					fixtures[key]['competition_region_name'] = fixtures[key].region_name + ' - ' + fixtures[key].competition_name;

					if (favouritesStore.favouriteFixtureIds.includes(fixtures[key].id)) {
						fixtures[key]['favourite'] = true;
					}
				}
			}

			const competitions = _.chain(fixtures).orderBy(['competition_weight', 'competition_region_name'], ['desc', 'asc']).groupBy('competition_region_name').value();

			for (const competition in competitions) {
				competitions[competition] = _.chain(competitions[competition]).orderBy(['start_datetime', 'asc']).value();
			}

			return competitions;
		},
		getSelectedCompetionsFixturesCount(state) {
			const regions_store = useRegionsStore();

			const raw_regions = regions_store.regions_competitions;
			const current_regions = _.isArray(raw_regions) ? raw_regions : Object.values(raw_regions || {});

			if (current_regions.length === 0) return 0;

			let total_fixtures = 0;

			if (state.competition_ids.length > 0) {
				state.competition_ids.forEach((selected_id) => {
					const region = _.find(current_regions, (r) => {
						return r.competitions && _.has(r.competitions, selected_id);
					});

					if (region) {
						total_fixtures += region.competitions[selected_id].pre_fixtures_count || 0;
					}
				});
			} else {
				current_regions.forEach(region => {
					if (region.competitions) {
						const comps_array = Object.values(region.competitions);
						total_fixtures += _.sumBy(comps_array, 'pre_fixtures_count') || 0;
					} else if (region.fixtures_count) {
						total_fixtures += region.pre_fixtures_count;
					}
				});
			}

			return total_fixtures;
		}
	},
	actions: {
		fetchNextHourFixtures(payload) {
			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + payload.sport_id + '/fixtures-upcoming/' + payload.hours, { withCredentials: false }).then((response) => {
				this.next_hour_fixtures = response.data;
				this.fixtures_loading = false;
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error)
			});
		},
		toggleCheckboxCompetition(competition_id) {
			if (this.competition_ids.includes(competition_id)) {
				this.competition_ids = _.remove(this.competition_ids, function(array_competition_id) {
					return array_competition_id != competition_id
				});

				return;
			}

			this.competition_ids.push(competition_id);
		},
		pruneSelectedCompetitions(available_regions) {
			const valid_ids = _.flatMap(available_regions, (region) => {
				return Object.values(region.competitions || {}).map(comp => comp.id);
			});

			this.competition_ids = this.competition_ids.filter(id => valid_ids.includes(id));
		},
		emptyNextHourFixtures() {
			this.next_hour_fixtures = null;
		},
		setFixturesLoading(data) {
			this.fixtures_loading = data;
		},
		toggleAllExpanded() {
			this.all_expanded = !this.all_expanded;
		},
		emptyCompetitionsIds() {
			this.competition_ids = [];
		},
		setCompetitionState(id, should_be_selected) {
			const index = this.competition_ids.indexOf(id);
			const is_currently_selected = index !== -1;

			if (should_be_selected && !is_currently_selected) this.competition_ids.push(id);
			else if (!should_be_selected && is_currently_selected) this.competition_ids.splice(index, 1);
		}
	}
})